import React, { Component } from 'react';
import { Form, Row, Col, AutoComplete, Select, Input, InputNumber, Radio, Checkbox, DatePicker, message, Button, Spin } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';
import './style.less';

const { Option } = Select;
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;
const { MonthPicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD';
const monthFormat = 'YYYY-MM';
const secondFormat = 'YYYY-MM-DD HH:mm:ss';

const formId = {};
const searchInputList = {};
const NeedRequerDate = [ 
    '实际递交立项资料的日期', 
    '实际伦理资料递交日期', 
    '实际伦理上会日期',
    '实际伦理批件获取日期',
    '实际合同初稿给机构审核的日期',
    '实际合同定稿日期',
    '实际合同签署日期',
];

class EditForm extends Component {
    state = {
        loading: false,
        isSiteDateRequire: false,
        siteRadioIsChanged: false,
        actualSiteDate: false,
        actualSiteDateEdit: false,
        haveSsuLeader: this.props.haveSsuLeader,
    }

    componentDidMount() {
        const { form, edit } = this.props;
        for (const [key, item] of Object.entries(searchInputList || {})) {
            const { getFieldDecorator } = form;
            getFieldDecorator(`${key}_list`, { initialValue: [] });
            edit && this.handleSearch(item.valueShow, item, 'immediate');
        }
    }

    normalize = (value, prevValue, allValues, item) => {
        const { getFieldValue } = this.props.form;
        const { ssuModuleStructureDefineId: id, ssuModuleStructureDefineName } = item;
        let startValue;
        let endValue;
        if (ssuModuleStructureDefineName === 'site启动时长') {
            startValue = getFieldValue(`${425}`);
            endValue = getFieldValue(`${324}`);
        } else {
            startValue = getFieldValue(`${id - 2}`);
            endValue = getFieldValue(`${id - 1}`);
        }
        let newValue;
        if (startValue && endValue) {
            startValue = moment(startValue).format(dateFormat);
            endValue = moment(endValue).format(dateFormat);
            newValue = (moment(startValue).valueOf() - moment(endValue).valueOf()) / (24 * 60 * 60 * 1000);
        }
        return newValue;
    }

    clearValue = field => {
        const { form: { setFieldsValue } } = this.props;
        setFieldsValue({ [field]: '' });
    }

    needRequerDate = (ssuModuleStructureDefineName, ssuModuleStructureDefineId, ssuModuleStructureId) => {
        const { actualSiteDateEdit } = this.state;
        const { form:{ getFieldValue } } = this.props;
        const siteDate = getFieldValue(`${ssuModuleStructureDefineId}`);
        if(ssuModuleStructureDefineName == '实际site启动日期' && ssuModuleStructureId == 10 && !actualSiteDateEdit) {
            this.setState({ actualSiteDate: siteDate ? true : false, actualSiteDateEdit: true })
        }
        return NeedRequerDate.find( el => ssuModuleStructureDefineName == el )
    }

    handleDateChange = (date, dateString, ssuModuleStructureDefineId, ssuModuleStructureDefineName, ssuModuleStructureId) => {
        const option = formId[ssuModuleStructureDefineId] || {};
        const relationValueId = option.relationValueId;
        if( ssuModuleStructureDefineName == '实际site启动日期' && ssuModuleStructureId == 10) {//
            this.setState({ actualSiteDate: dateString ? true : false })
        }
        // if (relationValueId) {
        //     this.props.form.setFieldsValue({ [relationValueId]: date });
        // }
        return date;
    }

    // CRC姓名赋值CRC工号
    normFile = (value, item, list) => {
        const { form: { setFieldsValue } } = this.props;
        const { ssuModuleStructureDefineId } = item;
        const employeeCode = ((list || []).find(i => i.userId == value) || {}).employeeCode;
        setFieldsValue({ [`${ssuModuleStructureDefineId + 1}`]: employeeCode });
        return value;
    }

    disabledDate = (current, ssuModuleStructureDefineIsCheckDate) => {
        if (ssuModuleStructureDefineIsCheckDate == 1) {
            const { maxDate } = this.props;
            const value = moment(moment(maxDate).format(dateFormat)).add(1, 'd').valueOf();
            return current && current.valueOf() >= value;
        }
    }

    handleSearch = (value, item, type) => {
        const { siteId } = sessionStorage;
        const { ssuModuleStructureDefineId, ssuModuleStructureDefineName } = item;
        const { form: { setFieldsValue, getFieldValue }, hospitalId } = this.props;
        const queryData = () => {
            let keyword = value;
            if (value && value.indexOf('[') && (`${value}`).endsWith(']')) {
                keyword = value.slice(0, value.indexOf('['));
            }
            const options = {
                method: 'POST',
                url: API_URL.hospital.queryInvestigationSiteUser,
                data: {
                    limit: 20,
                    keyword,
                    investigationSiteId: hospitalId || siteId,
                    ssuModuleStructureDefineId,
                },
                dataType: 'json',
                doneResult: res => {
                    const data = (res.data || []).map(i => {
                        const { userId, employeeCode, userCompellation } = i;
                        return {
                            value: userId,
                            text: userCompellation,
                            ...i,
                        };
                    });
                    setFieldsValue({ [`${ssuModuleStructureDefineId}_list`]: data });
                },
            };
            $.sendRequest(options);
        };
        if (type === 'immediate') {
            queryData();
        } else {
            if (type === 'focus' && getFieldValue(`${ssuModuleStructureDefineId}_list`)) {
                return;
            }
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(queryData, 300);
        }
    }

    validateSearchInput = (rule, value, callback) => {
        const { id, name, required } = rule;
        const list = this.props.form.getFieldValue(`${id}_list`) || [];
        if (value) {
            const idx = list.findIndex(i => i.value == value);
            if (idx >= 0) {
                callback();
            } else {
                callback(`请选择正确的${name}`);
            }
        } else {
            required ? callback(`请选择${name}`) : callback();
        }
    }

    handleRadioChange = (value, name) => {
        if(name == '中心是否取消'){
            this.setState({isSiteDateRequire: value == 1198 ? false : true, siteRadioIsChanged:true },
                () => {
                    this.props.form.validateFields(['424'], { force: true });
                })
        }
    } 

    getWebType = item => {
        const { edit, form } = this.props;
        const { getFieldDecorator, getFieldValue } = form;
        const disabled = item.isDisabled === '1';
        const isRequire = item.ssuModuleStructureDefineIsRequire === '1';
        let dom = null;
        if (item.ssuModuleStructureDefineWebType == 'TEXT_RADIO') {
            const options = item.ssuModuleStructureDefineOptionList.map(i => (
                <Radio
                    key={i.ssuModuleStructureDefineOptionId}
                    value={i.ssuModuleStructureDefineOptionId}
                >{i.ssuModuleStructureDefineOptionName}</Radio>
            ));
            dom = (
                <span key={`${item.ssuModuleStructureDefineId}_value`}>
                    {
                        edit ?
                            getFieldDecorator(`${item.ssuModuleStructureDefineId}`, {
                                rules: [{ 
                                    required: isRequire,
                                    message: `请选择${item.ssuModuleStructureDefineName}` 
                                }],
                            })(
                                <RadioGroup disabled={disabled} onChange={e => this.handleRadioChange(e.target.value,item.ssuModuleStructureDefineName)}>
                                    {options}
                                    {!disabled && <span className="clearValue" onClick={() => this.clearValue(item.ssuModuleStructureDefineId)}>×</span>}
                                </RadioGroup>,
                            )
                        :
                            getFieldValue(`${item.ssuModuleStructureDefineId}`)
                    }
                </span>
            );
        } else if (item.ssuModuleStructureDefineWebType == 'TEXT_CHECKBOX') {
            const options = item.ssuModuleStructureDefineOptionList.map(i => ({
                label: i.ssuModuleStructureDefineOptionName,
                value: i.ssuModuleStructureDefineOptionId,
            }));
            dom = (
                <span key={`${item.ssuModuleStructureDefineId}_value`}>
                    {
                        edit ?
                            getFieldDecorator(`${item.ssuModuleStructureDefineId}`, {
                                rules: [{ required: isRequire, message: `请选择${item.ssuModuleStructureDefineName}` }],
                            })(
                                <CheckboxGroup disabled={disabled} options={options} />,
                            )
                        :
                            getFieldValue(`${item.ssuModuleStructureDefineId}`)
                    }
                </span>
            );
        } else if (item.ssuModuleStructureDefineWebType == 'TEXT_AREA') {
            dom = (
                <span key={`${item.ssuModuleStructureDefineId}_value`}>
                    {
                        edit ?
                            getFieldDecorator(`${item.ssuModuleStructureDefineId}`, {
                                rules: [{ required: isRequire, message: `请输入${item.ssuModuleStructureDefineName}` }],
                            })(
                                <Input disabled={disabled} placeholder={!disabled ? '请输入' : null} style={{ width: 240 }} />,
                            )
                        :
                            getFieldValue(`${item.ssuModuleStructureDefineId}`)
                    }
                </span>
            );
        } else if (item.ssuModuleStructureDefineWebType == 'NUMBER_AREA') {
            dom = (
                <span key={`${item.ssuModuleStructureDefineId}_value`}>
                    {
                        edit ?
                            ((item.ssuModuleStructureDefineName.endsWith('日期偏差') || item.ssuModuleStructureDefineName === 'site启动时长') &&
                            <Col span={7}>
                                {
                                    getFieldDecorator(`${item.ssuModuleStructureDefineId}`, {
                                        normalize: (value, prevValue, allValues) => this.normalize(value, prevValue, allValues, item),
                                    })(
                                        <InputNumber disabled style={{ width: 153 }} />,
                                    )
                                }
                            </Col>)
                            ||
                            <Col span={15}>
                                {
                                    getFieldDecorator(`${item.ssuModuleStructureDefineId}`, {
                                        rules: [{ required: isRequire, message: `请输入${item.ssuModuleStructureDefineName}` }],
                                    })(
                                        <InputNumber disabled={disabled} style={{ width: 240 }} />,
                                    )
                                }
                            </Col>
                        :
                            getFieldValue(`${item.ssuModuleStructureDefineId}`)
                    }
                    {
                        edit ?
                            item.ssuModuleStructureDefineUnit
                        :
                            (getFieldValue(`${item.ssuModuleStructureDefineId}`) && item.ssuModuleStructureDefineUnit)
                    }
                </span>
            );
        } else if (item.ssuModuleStructureDefineWebType == 'DATE_AREA') {
            let date;
            if (item.ssuDataFormat) {
                if (item.ssuDataFormat.ssuDataFormatValue == 'yyyy-MM-dd') {
                    date = <DatePicker disabled={disabled} disabledDate={current => this.disabledDate(current, item.ssuModuleStructureDefineIsCheckDate)} placeholder={!disabled ? '请选择' : null} />;
                } else if (item.ssuDataFormat.ssuDataFormatValue == 'yyyy-MM') {
                    date = <MonthPicker disabled={disabled} placeholder={!disabled ? '请选择' : null} />;
                } else if (item.ssuDataFormat.ssuDataFormatValue == 'yyyy-MM-dd HH:mm:ss') {
                    date = <DatePicker disabled={disabled} placeholder={!disabled ? '请选择' : null} format="YYYY-MM-DD HH:mm:ss" showTime />;
                }
            }
            dom = (
                <span key={`${item.ssuModuleStructureDefineId}_value`}>
                    {
                        edit ?
                            getFieldDecorator(`${item.ssuModuleStructureDefineId}`, {
                                rules: [{ 
                                    type: 'object', 
                                    required: (item.ssuModuleStructureDefineName == '计划site启动日期' && this.state.siteRadioIsChanged) ? 
                                    this.state.isSiteDateRequire
                                    : this.needRequerDate(item.ssuModuleStructureDefineName, item.ssuModuleStructureDefineId, item.ssuModuleStructureId) && item.ssuModuleStructureId == 10 ? 
                                    this.state.actualSiteDate && this.state.haveSsuLeader
                                    : isRequire, 
                                    message: `请选择${item.ssuModuleStructureDefineName}` }],
                                getValueFromEvent: (date, dateString) => this.handleDateChange(date, dateString, item.ssuModuleStructureDefineId, item.ssuModuleStructureDefineName, item.ssuModuleStructureId),
                            })(
                                date,
                            )
                        :
                            getFieldValue(`${item.ssuModuleStructureDefineId}`)
                    }
                </span>
            );
        } else if (item.ssuModuleStructureDefineWebType == 'TEXT_SEARCH_INPUT') {
            searchInputList[item.ssuModuleStructureDefineId] = item;
            const list = getFieldValue(`${item.ssuModuleStructureDefineId}_list`) || [];
            const options = list.map(i => (
                <Option key={String(i.value)}>{i.text}</Option>
            ));
            dom = (
                <span key={`${item.ssuModuleStructureDefineId}_value`}>
                    {
                        edit ?
                            getFieldDecorator(`${item.ssuModuleStructureDefineId}`, {
                                getValueFromEvent: value => this.normFile(value, item, list),
                                rules: [
                                    {
                                        required: isRequire,
                                        id: item.ssuModuleStructureDefineId,
                                        name: item.ssuModuleStructureDefineName,
                                        validator: this.validateSearchInput,
                                    },
                                ],
                            })(
                                <AutoComplete
                                    allowClear
                                    onSearch={value => this.handleSearch(value, item, 'search')}
                                    onFocus={() => this.handleSearch('', item, 'focus')}
                                    disabled={disabled}
                                    style={{ width: 240 }}
                                    placeholder={!disabled ? '输入检索' : null}
                                >
                                    {options}
                                </AutoComplete>,
                            )
                        :
                            getFieldValue(`${item.ssuModuleStructureDefineId}`)
                    }
                </span>
            );
        }
        return dom;
    }

    getContent = () => {
        const { formData } = this.props;
        let content = null;
        if (formData && formData.length > 0) {
            content = formData.map(item => (
                <div key={item.ssuModuleStructureDefineId}>
                    <div
                        style={{ marginBottom: 10, fontSize: '14px', lineHeight: '42px', fontWeight: 'bold', borderBottom: '1px solid #999' }}
                    >{item.ssuModuleStructureDefineName}</div>
                    { item.children && item.children.length > 0 && this.getChildren(item.children) }
                </div>
                ));
        }
        return content;
    }

    getShowState = data => {
        let isShow = false;
        const { edit, form } = this.props;
        const { getFieldValue } = form;
        if (data.ssuModuleStructureDefineDisplayDetailList && data.ssuModuleStructureDefineDisplayDetailList.length > 0) {
            if (data.oper == 'AND') {
                isShow = data.ssuModuleStructureDefineDisplayDetailList.every(item => {
                    const value = getFieldValue(item.refSsuModuleStructureDefineId);
                    const refValue = formId[item.refSsuModuleStructureDefineId].value || '';
                    if (item.detailOper == 'EQ') {
                        if (edit) {
                            if (Array.isArray(value)) {
                                return value.indexOf(Number(item.value)) >= 0;
                            }
                            return item.value == value;
                        }
                        return refValue.indexOf(item.value) >= 0;
                    } else if (item.detailOper == 'NEQ') {
                        if (edit) {
                            if (Array.isArray(value)) {
                                return value.indexOf(Number(item.value)) < 0;
                            }
                            return item.value != value;
                        }
                        return refValue.indexOf(item.value) < 0;
                    }
                });
            } else if (data.oper == 'OR') {
                isShow = data.ssuModuleStructureDefineDisplayDetailList.some(item => {
                    const value = getFieldValue(item.refSsuModuleStructureDefineId);
                    const refValue = formId[item.refSsuModuleStructureDefineId].value || '';
                    if (item.detailOper == 'EQ') {
                        if (edit) {
                            if (Array.isArray(value)) {
                                return value.indexOf(Number(item.value)) >= 0;
                            }
                            return item.value == value;
                        }
                        return refValue.indexOf(item.value) >= 0;
                    } else if (item.detailOper == 'NEQ') {
                        if (edit) {
                            if (Array.isArray(value)) {
                                return value.indexOf(Number(item.value)) < 0;
                            }
                            return item.value != value;
                        }
                        return refValue.indexOf(item.value) < 0;
                    }
                });
            }
        }
        return isShow;
    }

    getMastSpan = (item = {}) => {
        const { isSiteDateRequire, siteRadioIsChanged } = this.state;
        const { ssuModuleStructureDefineIsAsterisk, ssuModuleStructureDefineName} = item;
        let isAsterisk  =null;
        if(ssuModuleStructureDefineName == '计划site启动日期' && siteRadioIsChanged ){
            isAsterisk = isSiteDateRequire ? 
                <span style={{ float: 'left', lineHeight: '28px', color: 'red' }}>*</span> 
            :
                <span span style={{ float: 'left', lineHeight: '28px' }}>&nbsp;&nbsp;</span>
        }else {
            isAsterisk = ssuModuleStructureDefineIsAsterisk === '1' ?
                <span style={{ float: 'left', lineHeight: '28px', color: 'red' }}>*</span> 
            :
                <span span style={{ float: 'left', lineHeight: '28px' }}>&nbsp;&nbsp;</span>
        }
        return isAsterisk
    }

    getChildren = data => {
        const FormItemLayout = {
            colon: false,
            labelCol: {
                sm: { span: 7 },
            },
            wrapperCol: {
                sm: { span: 16, offset: 1 },
            },
        };
        const content = data.map(item => {
            formId[item.ssuModuleStructureDefineId] = item;
            const isAsterisk = this.getMastSpan(item);
            const isColor = item.ssuModuleStructureDefineIsColor === '1';
            const isShow = item.ssuModuleStructureDefineDisplay ? this.getShowState(item.ssuModuleStructureDefineDisplay) : true;
            if (isShow) {
                return (
                    <Row key={item.ssuModuleStructureDefineId} style={{ background: isColor && '#f5f5f5' }}>
                        <Col span={24} className="text_left">
                            <FormItem
                                {...FormItemLayout}
                                label={<div>{isAsterisk}<div className="text_left_label" title={item.ssuModuleStructureDefineName}>{item.ssuModuleStructureDefineName}</div></div>}
                            >
                                {this.getWebType(item)}
                            </FormItem>
                        </Col>
                    </Row>
                );
            }
        });
        return content;
    }

    isDateInRange = (dateToCheck) => {
        if (!dateToCheck) {
            return true
        }
        const { investigationPlanBeginTime, investigationPlanEndTime } = this.props;
        const startDate = moment(investigationPlanBeginTime);
        const endDate = moment(investigationPlanEndTime);
        return moment(dateToCheck).isBetween(startDate, endDate, 'day', '[]');
    };

    submit = () => {
        const { hospitalId, ssuModuleStructureId } = this.props;
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (err) {
                return;
            }
            let index = 0;
            const params = {};
            const array = Object.keys(values);
            array.forEach(item => {
                const key = Number(item);
                if (!isNaN(key) && formId[item]) {
                    const option = formId[item];
                    if (option.ssuHospitalStructureId) {
                        params[`ssuHospitalStructures[${index}].ssuHospitalStructureId`] = option.ssuHospitalStructureId;
                    }
                    if (option.ssuModuleStructureDefineWebType == 'TEXT_CHECKBOX') {
                        let text = '';
                        if (values[item]) {
                            text = values[item].join(',');
                        }
                        params[`ssuHospitalStructures[${index}].value`] = text;
                    } else if (option.ssuModuleStructureDefineWebType == 'DATE_AREA') {
                        let value = '';
                        if (option.ssuDataFormat) {
                            if (option.ssuDataFormat.ssuDataFormatValue == 'yyyy-MM-dd') {
                                value = values[item] && values[item].format(dateFormat);
                            } else if (option.ssuDataFormat.ssuDataFormatValue == 'yyyy-MM') {
                                value = values[item] && values[item].format(monthFormat);
                            } else if (option.ssuDataFormat.ssuDataFormatValue == 'yyyy-MM-dd HH:mm:ss') {
                                value = values[item] && values[item].format(secondFormat);
                            }
                        }
                        params[`ssuHospitalStructures[${index}].value`] = value;
                    } else {
                        params[`ssuHospitalStructures[${index}].value`] = values[item];
                    }
                    params[`ssuHospitalStructures[${index}].type`] = 'INVESTIGATION_SITE';
                    params[`ssuHospitalStructures[${index}].hospitalId`] = hospitalId;
                    params[`ssuHospitalStructures[${index}].ssuModuleStructureId`] = option.ssuModuleStructureId;
                    params[`ssuHospitalStructures[${index}].ssuModuleStructureDefineId`] = option.ssuModuleStructureDefineId;
                    params[`ssuHospitalStructures[${index}].ssuModuleStructureDefineWebType`] = option.ssuModuleStructureDefineWebType;
                    index++;
                }
            });
            //中心关闭记录保存时需新增校验：项目计划开始时间≤关闭中心完成时间≤项目计划结束时间
            //中心启动记录保存时需新增校验：项目计划开始时间≤计划site启动日期≤项目计划结束时间；项目计划开始时间≤计划递交立项资料日期≤项目计划结束时间；
            let siteCloseTime,siteStartTime,projectInitiationTime = '';
            for (let index = 0; index < Object.keys(params).length; index++) {
                if (params[`ssuHospitalStructures[${index}].ssuModuleStructureDefineId`] == 565) {
                    siteCloseTime = params[`ssuHospitalStructures[${index}].value`];
                }
                if (params[`ssuHospitalStructures[${index}].ssuModuleStructureDefineId`] == 424) {
                    siteStartTime = params[`ssuHospitalStructures[${index}].value`];
                }
                if (params[`ssuHospitalStructures[${index}].ssuModuleStructureDefineId`] == 323) {
                    projectInitiationTime = params[`ssuHospitalStructures[${index}].value`];
                }
            }
            const isInSiteCloseRange = this.isDateInRange(siteCloseTime);
            const isInSiteStartRange = this.isDateInRange(siteStartTime) && this.isDateInRange(projectInitiationTime);
            if (!isInSiteCloseRange) {
                return message.warning('关闭中心完成时间不在项目计划时间范围内');
            }
            if (!isInSiteStartRange) {
                return message.warning('计划site启动日期或计划递交立项资料日期不在项目计划时间范围内');
            }
            this.setState({ loading: true });
            const options = {
                method: 'POST',
                url: API_URL.hospital.addSsuModuleStructureDetail,
                data: {
                    ssuModuleStructureId,
                    hospitalId,
                    ...params,
                },
                dataType: 'json',
                doneResult: res => {
                    message.success(res.success);
                    this.setState({ loading: false }, () => {
                        this.props.changeEdit();
                    });
                },
                errorResult: () => {
                    this.setState({ loading: false });
                },
            };
            $.sendRequest(options);
        });
    }

    render() {
        const { loading } = this.state;
        const { edit, curRole, changeEdit } = this.props;
        const isShow = curRole == 'PM' || curRole == 'PA' || curRole == 'CRC' || curRole == 'CSA';
        return (
            <Spin spinning={loading}>
                <div style={{ marginTop: 10, height: 500, overflowY: 'auto' }}>
                    <Form hideRequiredMark ref={el => this.form = el}>
                        { this.getContent() }
                    </Form>
                </div>
                {
                    (isShow && edit) &&
                    <div style={{ margin: '8px 0', textAlign: 'center' }}>
                        <Button
                            key="save"
                            type="primary"
                            htmlType="submit"
                            onClick={this.submit}
                        >保存</Button>
                        <Button
                            key="cancle"
                            type="primary"
                            style={{ marginLeft: 10 }}
                            onClick={() => changeEdit()}
                        >取消</Button>
                    </div>
                }
            </Spin>
        );
    }
}

class EditSiteForm extends Component {
    state = {
        formData: [],
        curRole: '',
        maxDate: '',
        haveSsuLeader: false,
        investigationPlanBeginTime: '',
        investigationPlanEndTime: '',
    }

    componentDidMount() {
        const { ssuModuleStructureId } = this.props;
        const { siteId, hospitalId } = sessionStorage;
        let id;
        if (siteId != 0) {
            id = siteId;
        } else {
            id = hospitalId;
        }
        this.queryEffectiveDate();
        this.setState({
            hospitalId: id,
            ssuModuleStructureId,
            curRole: sessionStorage.curRole,
        }, () => {
            this.loadFormData();
        });
    }

    queryEffectiveDate = () => {
        const options = {
            method: 'POST',
            url: API_URL.home.queryEffectiveDate,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { date } = res;
                const maxDate = date;
                this.setState({ maxDate });
            },
        };
        $.sendRequest(options);
    }

    loadFormData = () => {
        const { hospitalId, ssuModuleStructureId } = this.state;
        const { setHospitalSsuDisable } = this.props;
        const options = {
            method: 'POST',
            url: API_URL.hospital.querySsuModuleStructureDetail,
            data: {
                hospitalId,
                ssuModuleStructureId,
                type: 'INVESTIGATION_SITE',
            },
            dataType: 'json',
            doneResult: res => {
                const { investigationPlanBeginTime, investigationPlanEndTime } = res.investigation || {};
                this.setState({
                    formData: res.data,
                    haveSsuLeader: res.haveSsuLeader,
                    investigationPlanBeginTime,
                    investigationPlanEndTime,
                },this.handleSiteDateIsRequire);
                setHospitalSsuDisable && setHospitalSsuDisable(res.hospitalSsuDisable)
            },
        };
        $.sendRequest(options);
    }

    componentDidUpdate(prevProps) {
        if (!this.props.edit && prevProps.edit) {
            this.loadFormData();
        }
    }
    
    handleFormData = data => {
        this.setState({ formData:data })
    }

    handleSiteDateIsRequire = () => {
        const { formData } = this.state;
        formData.forEach((el, index1)=> {
            el.children.forEach((item, index2) => {
                if(item.ssuModuleStructureDefineId == 641 && item.value == 1198){
                    formData[index1].children[index2-1].ssuModuleStructureDefineIsAsterisk = '0'
                    formData[index1].children[index2-1].ssuModuleStructureDefineIsRequire = '0'
                }
            })
        })
        this.handleFormData(formData)
    }

    changeEdit = () => {
        this.props.changeEdit();
        window.scrollTo(0, 0);
    }

    getFormValue = (data, params) => {
        const { edit } = this.props;
        data.forEach(item => {
            if (item.ssuModuleStructureDefineWebType == 'TEXT_AREA' || item.ssuModuleStructureDefineWebType == 'NUMBER_AREA') {
                params[item.ssuModuleStructureDefineId] = { value: item.value };
            } else if (item.ssuModuleStructureDefineWebType == 'TEXT_RADIO') {
                const itemValue = (!item.value && item.value !== 0 && item.defaultValue) ? item.defaultValue : item.value;
                if (edit) {
                    let value = itemValue;
                    if (item.ssuModuleStructureDefineWebType == 'TEXT_RADIO') {
                        value = itemValue && Number(itemValue);
                    }
                    params[item.ssuModuleStructureDefineId] = { value };
                } else {
                    let value = '';
                    item.ssuModuleStructureDefineOptionList.forEach(i => {
                        if (i.ssuModuleStructureDefineOptionId == itemValue) {
                            value = i.ssuModuleStructureDefineOptionName;
                        }
                    });
                    params[item.ssuModuleStructureDefineId] = { value };
                }
            } else if (item.ssuModuleStructureDefineWebType == 'TEXT_CHECKBOX') {
                if (edit) {
                    let value = null;
                    if (item.value) {
                        const array = item.value.split(',');
                        value = array.map(i => Number(i));
                    }
                    params[item.ssuModuleStructureDefineId] = { value };
                } else {
                    let value = '';
                    if (item.value) {
                        const array = item.value.split(',');
                        array.forEach(i => {
                            item.ssuModuleStructureDefineOptionList.forEach(j => {
                                if (j.ssuModuleStructureDefineOptionId == i) {
                                    value += `,${j.ssuModuleStructureDefineOptionName}`;
                                }
                            });
                        });
                    }
                    const newValue = value ? value.substring(1) : '';
                    params[item.ssuModuleStructureDefineId] = { value: newValue };
                }
            } else if (item.ssuModuleStructureDefineWebType == 'DATE_AREA') {
                if (edit) {
                    let value = null;
                    if (item.value) {
                        value = moment(item.value);
                    }
                    params[item.ssuModuleStructureDefineId] = { value };
                } else {
                    params[item.ssuModuleStructureDefineId] = { value: item.value };
                }
            } else if (item.ssuModuleStructureDefineWebType == 'TEXT_SEARCH_INPUT') {
                if (edit) {
                    params[item.ssuModuleStructureDefineId] = { value: item.value };
                } else {
                    params[item.ssuModuleStructureDefineId] = { value: item.valueShow };
                }
            }
        });
    }

    render() {
        const { edit } = this.props;
        const { curRole, maxDate, formData, hospitalId, ssuModuleStructureId, haveSsuLeader, investigationPlanBeginTime, investigationPlanEndTime } = this.state;
        const params = {};
        formData.forEach(item => {
            if (item.children && item.children.length > 0) {
                this.getFormValue(item.children, params);
            }
        });
        const mapPropsToFields = () => ({
            ...params,
        });
        const EditForms = Form.create({ mapPropsToFields })(EditForm);
        return (
            <EditForms
                edit={edit}
                curRole={curRole}
                maxDate={maxDate}
                formData={formData}
                hospitalId={hospitalId}
                haveSsuLeader={haveSsuLeader}
                changeEdit={this.changeEdit}
                handleFormData={this.handleFormData}
                ssuModuleStructureId={ssuModuleStructureId}
                investigationPlanBeginTime={investigationPlanBeginTime}
                investigationPlanEndTime={investigationPlanEndTime}
            />
        );
    }
}

export default EditSiteForm;



// WEBPACK FOOTER //
// ./src/components/common/siteTemplate/index.js